import { createSlice } from '@reduxjs/toolkit';

import SDK from '../Components/SDK';
import { getUserIdFromJid } from '../Helpers/Utility';
import { clearState } from './clearSlice';

// Keyed by conversation: the server caps pins per conversation and only ever returns
// one conversation's pins, so a flat list would mix chats together.
const initialState = {
    byChatId: {},
};

const pinnedMessagesSlice = createSlice({
    name: 'pinnedMessages',
    initialState,
    reducers: {
        setPinnedMessages(state, action) {
            const { chatId, messages = [] } = action.payload || {};
            if (!chatId) return;
            state.byChatId[chatId] = messages;
        },
        removePinnedMessage(state, action) {
            const { chatId, msgId } = action.payload || {};
            const messages = state.byChatId[chatId];
            if (!messages) return;
            state.byChatId[chatId] = messages.filter(message => message.msgId !== msgId);
        },
        clearPinnedMessages(state, action) {
            delete state.byChatId[action.payload];
        },
    },
    extraReducers: builder => {
        builder.addCase(clearState, () => initialState);
    },
});

export const { setPinnedMessages, removePinnedMessage, clearPinnedMessages } = pinnedMessagesSlice.actions;

export const selectPinnedMessages = (state, chatId) => state.pinnedMessages.byChatId[chatId] || [];

// The pin push carries no message body and the message often sits outside the loaded
// history page, so the list is re-fetched rather than patched from the push.
export const fetchPinnedMessages = chatJid => async dispatch => {
    if (!chatJid) return;
    const response = await SDK.getPinnedMessages(chatJid);
    if (response?.statusCode !== 200) return;
    dispatch(setPinnedMessages({ chatId: getUserIdFromJid(chatJid), messages: response.data || [] }));
};

export default pinnedMessagesSlice.reducer;
